// extracted by mini-css-extract-plugin
module.exports = {"bg":"_1vnzj","inlineContent":"_2egft","pageWrapper":"_3akMP"};